export default "__VITE_ASSET___0V0bcH5__"